import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import axios from "axios";
import { url } from "../../utils/url";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [userName, setUserName] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const loginHandler = async () => {
    setError(null);
    try {
      const request = await axios.post(
        `${url}login`,
        {
          userName: userName,
          password: userPassword,
        },
        { withCredentials: true }
      );
      request.data.userRole.name === "Administrator" ? navigate("/admin") : navigate("/driver");
    } catch (err) {
      console.log(err);
      setError("Възникна проблем! Моля опитайте по-късно");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(/1taxi.jpeg)`,
        backgroundSize: {
          xs: "100%",
          lg: "50%",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          borderRadius: "7px",
          padding: "20px",
          marginBottom: "20%",
          gap: "30px",
          width: {
            xs: "85%",
            lg: "40%",
          },
        }}
      >
        <Typography align="center" variant="h3">
          Вход
        </Typography>
        <TextField id="Потребителско име" label="Потребителско име" value={userName} onChange={(e) => setUserName(e.target.value)} />
        <TextField id="Парола" label="Парола" type="password" value={userPassword} onChange={(e) => setUserPassword(e.target.value)} />
        {error && (
          <Typography color="red" align="center">
            {error}
          </Typography>
        )}
        <Button onClick={loginHandler} variant="contained">
          Вход
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
